import { DEFAULT_FLEXIBLE_DURATION_RANGE } from 'constants/search'

export const HOTEL_SHORT_STAY_NIGHTS = '2'
export const HOTEL_MEDIUM_STAY_NIGHTS = '5'
export const HOTEL_DEFAULT_CUSTOM_NIGHTS = 7
export const HOTEL_MIN_NIGHTS = 1
export const HOTEL_MAX_NIGHTS = 30

const LEGACY_HOTEL_DURATION_TO_NIGHTS: Record<string, string> = {
  [DEFAULT_FLEXIBLE_DURATION_RANGE.SHORT_STAY]: HOTEL_SHORT_STAY_NIGHTS,
  [DEFAULT_FLEXIBLE_DURATION_RANGE.MEDIUM_STAY]: HOTEL_MEDIUM_STAY_NIGHTS,
  [DEFAULT_FLEXIBLE_DURATION_RANGE.LONG_STAY]: '8',
}

export function getExactHotelNights(duration: string | undefined): number | undefined {
  if (!duration || !/^\d+$/.test(duration)) return undefined
  const nights = Number(duration)
  return Number.isInteger(nights) && nights >= HOTEL_MIN_NIGHTS && nights <= HOTEL_MAX_NIGHTS ? nights : undefined
}

export function normalizeHotelFlexibleDuration(duration: string | undefined): string | undefined {
  if (!duration) return undefined
  if (duration === DEFAULT_FLEXIBLE_DURATION_RANGE.ANY_DURATION) return duration
  const mappedNights = LEGACY_HOTEL_DURATION_TO_NIGHTS[duration]
  if (mappedNights) return mappedNights
  return getExactHotelNights(duration)?.toString()
}

export function mapExtractedHotelNightsToDuration(nights: Array<number> | undefined): string {
  const validNights = nights?.filter(night => Number.isInteger(night) && night >= HOTEL_MIN_NIGHTS)
  if (!validNights?.length) return DEFAULT_FLEXIBLE_DURATION_RANGE.ANY_DURATION
  return Math.min(Math.min(...validNights), HOTEL_MAX_NIGHTS).toString()
}
